export default "__VITE_ASSET__BBgdOrRq__"